/* eslint-disable no-console */
import { InboxOutlined } from "@ant-design/icons";
import { Button, Form, Input, Modal, Select, Switch } from "antd";
import Dragger from "antd/lib/upload/Dragger";
import axios from "axios";

import { showErrorNotification, showSuccessNotification } from "../../../../utils/notification";
import MultipleTagInput from "../../../common-utils/MultipleTagInput";

const { Item } = Form;

const CreateMailingListModal = ({
  batchesList = [],
  coursesList = [],
  waitlistsList = [],
  isModalOpen = false,
  fileUploadBackendUrl = "",
  setIsModalOpen = () => {},
  handleListCreation = () => {}
}) => {
  const [form] = Form.useForm();

  const handleOk = () => {
    setIsModalOpen(false);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const handleFormSubmit = (values) => {
    const { customEmailsFileInfo = [] } = values;
    if (customEmailsFileInfo.length === 0) {
      values = { ...values, customEmailsFileInfo: undefined };
    } else {
      values = {
        ...values,
        customEmailsFileInfo: customEmailsFileInfo[customEmailsFileInfo.length - 1].response
      };
    }
    handleListCreation(values);
  };

  const FileUploadProp = {
    name: "file",
    multiple: false,
    action: fileUploadBackendUrl,
    customRequest: ({ file, onSuccess, onError }) => {
      const formData = new FormData();
      formData.append("file", file);

      axios
        .post(fileUploadBackendUrl, formData)
        .then((response) => {
          showSuccessNotification(`${file.name} file uploaded successfully.`);
          form.setFieldsValue({ customEmailsFileInfo: [response.data] });
          onSuccess(response.data);
        })
        .catch((error) => {
          showErrorNotification(error);
          onError(error);
        });
    },
    onChange(info) {
      const { status } = info.file;
      if (status !== "uploading") {
        console.log(info.file, info.fileList);
      }
      if (status === "done") {
        console.log("File upload successful!");
      } else if (status === "error") {
        console.log("File upload failed!");
      }
    }
  };

  return (
    <Modal
      title="Create Mailing List"
      open={isModalOpen}
      footer={[]}
      width="1000px"
      onOk={handleOk}
      onCancel={handleCancel}
    >
      <Form
        form={form}
        layout="vertical"
        name="create_mailing_list_modal_form"
        onFinish={handleFormSubmit}
      >
        <Item
          name="name"
          label="Name"
          rules={[
            {
              required: true,
              message: "Please enter the name!"
            }
          ]}
        >
          <Input />
        </Item>
        <Item name="batchIds" label="Batches">
          <Select mode="multiple" options={batchesList || []} showSearch allowClear />
        </Item>

        <Item name="courseIds" label="Courses">
          <Select mode="multiple" options={coursesList || []} showSearch allowClear />
        </Item>

        <Item name="batchIdsToRemove" label="Batches to Remove">
          <Select mode="multiple" options={batchesList || []} showSearch allowClear />
        </Item>

        <Item name="courseIdsToRemove" label="Courses to Remove">
          <Select mode="multiple" options={coursesList || []} showSearch allowClear />
        </Item>

        <Item
          name="waitlistConfigIds"
          label="Link Waitlists"
          tooltip="Completed members of the selected waitlists are added to this list's audience."
        >
          <Select mode="multiple" options={waitlistsList || []} showSearch allowClear />
        </Item>

        <Item name="allTLEUsers" label="Toggle on for All TLE Users" valuePropName="checked">
          <Switch />
        </Item>

        <Item name="customEmailsList" label="Emails">
          <MultipleTagInput />
        </Item>

        <Item
          name="customEmailsFileInfo"
          label="Custom Emails File"
          valuePropName="fileList"
          getValueFromEvent={(e) => (Array.isArray(e) ? e : e && e.fileList)}
        >
          <Dragger {...FileUploadProp}>
            <p className="ant-upload-drag-icon">
              <InboxOutlined />
            </p>
            <p className="ant-upload-text">
              Click or drag an <b>xlsx file</b> to this area to upload. File should contain the
              first column with emails.
            </p>
          </Dragger>
        </Item>

        <Item className="submit-btn">
          <Button type="primary" htmlType="submit">
            Create
          </Button>
        </Item>
      </Form>
    </Modal>
  );
};
export default CreateMailingListModal;
